import { portalAuthHttpClient } from '../utils/HttpRequestUtils'
import envConfigs from '../configs/envConfigs'

export const getListDraftResponse = async (data) => {
	const url = `${envConfigs.baseUrl}${envConfigs.listDraftUrl}`
	// /const url = 'http://localhost:3001/booking/bookingdetails/getlistTemplateNames'
	const response = await portalAuthHttpClient.post(url, data)
    return response.data
}
